<template>
  <div>
    <BlockUI v-if="loading">
      <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
    </BlockUI>

    <Sidebar />
    <div id="content-wrapper">
      <Topbar />
      <div class="container-fluid">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import MeService from "@/services/me";
import Sidebar from "@/components/sidebar/Sidebar";
import Topbar from "@/components/topbar/Topbar";

import { mapGetters } from "vuex";

import SpaceService from "@/services/space";

export default {
  components: {
    Sidebar,
    Topbar,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("currentUser", ["spaceId"]),
  },
  methods: {
    async initNotifications() {
      const { data: user } = await MeService.getCurrentUser();

      try {
        const token = await this.$messaging.getToken();

        if (
          !user.webTokens ||
          !user.webTokens.length ||
          !user.webTokens.includes(token)
        ) {
          switch (user.role) {
            case "space_owner": {
              await MeService.addSpaceownerNotificationToken(token);
              break;
            }
            case "superadmin": {
              await MeService.addAdminNotificationToken(token);
              break;
            }
          }
        }
      } catch (error) {
        user.webTokens.map(async (token) => {
          switch (user.role) {
            case "space_owner": {
              await MeService.deleteSpaceownerNotificationToken(token);
              break;
            }
            case "superadmin": {
              await MeService.deleteAdminNotificationToken(token);
              break;
            }
          }
        });
      }
    },

    async getSpace() {
      if (this.spaceId) {
        try {
          this.loading = true;

          const { data: space } = await SpaceService.getSpaceById(this.spaceId);

          this.$store.dispatch("space/setSpace", space);
        } catch (error) {
        } finally {
          this.loading = false;
        }
      }
    },
  },
  beforeMount() {
    this.getSpace();
  },
  created() {
    this.initNotifications();
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/style";

#content-wrapper {
  width: calc(100% - #{$sidebar-width});
  margin-left: $sidebar-width;
  background: $bg-light-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AppLayout.vue